<template>
  <v-app id="inspire">
    <v-navigation-drawer class="bgpeserta" v-model="rail" permanent border="0">
      <template v-slot:prepend>
        <v-sheet height="100%" class="py-3 pl-3 ">
                <v-icon size="80" color="primary">mdi-account-circle-outline</v-icon>
            </v-sheet>
      </template>

      <template v-slot:default>
        <v-sheet height="90" class="pl-0">
          <v-list>
            <v-list-item>
              <v-list-item-title class="text-h6 text-primary text-wrap font-weight-bold">{{
                useUserStore().user.firstName
              }}</v-list-item-title>
              <v-list-item-subtitle class="mt-2">{{
                useUserStore().user.username
              }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-sheet>


        <v-sheet class="bg-white mx-3 mt-7 pa-0" rounded>
          <v-list density="compact" nav class="mt-">
            <v-list-item v-for="n in links" class="text-primary" :key="n" :to="n.link" :title="n.name">
              <template v-slot:prepend>
                <v-icon class="custom-icon-primary" :icon="n.icon"></v-icon>
              </template>
            </v-list-item>
            <v-list-item class="text-primary" @click="rekap = !rekap" title="Rekap Pelatihan" value="Rekap Pelatihan">
              <template v-slot:prepend>
                <v-icon class="custom-icon-primary" icon="mdi-view-list"></v-icon>
              </template>
            </v-list-item>
          </v-list>
        </v-sheet>
      </template>
      <template v-slot:append>
        <v-list density="compact" nav>
          <v-list-item class="bg-primary text-white" title="Sign Out" @click="Logout()">
            <template v-slot:append>
              <v-icon icon="mdi-logout"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer location="right" v-model="rekap" border="0">
       <v-toolbar class="bg-primary text-center text-subtitle-1 rounded-lg" density="compact">
         <v-toolbar-title>Periode Pelatihan</v-toolbar-title>
       </v-toolbar>
      <v-timeline align="start" class="pl-1" density="compact" side="end">
        <v-timeline-item v-if="Array.isArray(useUserStore().pengaturan.DataPelatihan)" :dot-color="CekColor(useUserStore().pengaturan.DataPelatihan[0].tgl_mulai)
          " :icon="CekIcon(useUserStore().pengaturan.DataPelatihan[0].tgl_mulai)">
          <div>
            <h4 :class="`mt-n1 headline font-weight-light mb-4 text-primary`">
              Tanggal Mulai
            </h4>

            <span class="text-center text-subtitle" v-text="ConvertDate(
              useUserStore().pengaturan.DataPelatihan[0].tgl_mulai
            )
              "></span>
          </div>
        </v-timeline-item>
        <v-timeline-item v-for="(year, i) in years" :key="i" :dot-color="CekColor(year.tanggalJadwal)"
          :icon="CekIcon(year.tanggalJadwal)" size="small">
          <div>
            <h4 :class="`mt-n1 headline font-weight-light mb-4 text-primary`">
              {{ year.refJadwalDTO.jadwal }}
            </h4>
            <span class="text-center text-subtitle" v-text="ConvertDate(year.tanggalMulai)"></span>
          </div>
        </v-timeline-item>
        <v-timeline-item v-if="Array.isArray(useUserStore().pengaturan.DataPelatihan)" :dot-color="CekColor(useUserStore().pengaturan.DataPelatihan[0].tgl_akhir)
          " :icon="CekIcon(useUserStore().pengaturan.DataPelatihan[0].tgl_akhir)">
          <div>
            <h4 :class="`mt-n1 headline font-weight-light mb-4 text-primary`">
              Tanggal Selesai
            </h4>

            <span class="text-center text-subtitle" v-text="ConvertDate(
              useUserStore().pengaturan.DataPelatihan[0].tgl_akhir
            )
              "></span>
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-navigation-drawer>


    <v-app-bar flat height="60">
      <v-btn variant="text" :icon="rail ? 'mdi-chevron-right' : 'mdi-chevron-left'" @click.stop="rail = !rail"></v-btn>

      <Breadcrums class="mt-3" />
      <v-spacer></v-spacer>
      <NotifIcon class="mx-3" v-if="useUserStore().loggedIn" />
      <UserProfile class="mx-3" v-if="useUserStore().loggedIn" />
    </v-app-bar>

    <v-main style="padding-top: 5%;" class="bg-white">
      <v-sheet class="bg-grey-lighten-4 mr-3 mb-3 pa-5" height="100%" rounded="xl">
        <v-btn v-if="this.$route.fullPath != '/pim/Peserta'" color="primary" variant="outlined" rounded
          class="text-primary text-capitalize mb-3" @click="goBack()">
          <v-icon>mdi-arrow-left</v-icon> Kembali</v-btn>
        <NuxtPage />

      </v-sheet>
    </v-main>



    <FooterRole />
  </v-app>
</template>

<script>
import moment from "moment";
import "moment/dist/locale/id";

export default {
  components: {},
  data: () => ({
    rail: true,
    drawer: false,
    rekap: true,
    years: [],
    links: [
      {
        icon: "mdi-view-dashboard",
        link: "/pim/Peserta",
        name: "Dashboard",
      },
      {
        icon: "mdi-account-clock",
        link: "/pim/Peserta/Absensi",
        name: "Absensi",
      },
      {
        icon: "mdi-school",
        link: "/pim/Peserta/MulaiPelatihan",
        name: "Pelatihan",
      },
    ],
  }),
  mounted() {
    this.getJadwal();
    this.getDataPelatihan();
  },
  methods: {
    async getDataPelatihan() {
      this.loading = true;
      const event = useRequestEvent();

      try {
        const result = await fetchData(
          event,
          "/mgmt/user-mgmt-menu/angkatan/" +
          useUserStore().pengaturan.DataKuisPeserta.angkatan
        );

        this.Pelatihan = [result.data.cdiklatDTO];
        useUserStore().$patch({
          pengaturan: {
            DataPelatihan: [result.data.cdiklatDTO],
          },
        });
        this.loading = false;
      } catch (error) { }
      this.loading = false;
    },
    ConvertDate(date) {
      const tanggalDalamFormatYYYYMMDD = date;
      const tanggalBulanTahun = moment(tanggalDalamFormatYYYYMMDD)
        .locale("id")
        .format("dddd, DD MMMM YYYY ");
      return tanggalBulanTahun;
    },
    async getJadwal() {
      this.loading = true;
      const event = useRequestEvent();
      const userStore = useUserStore();
      const option = {
        size: 10,
        angkatanId: useUserStore().pengaturan.DataKuisPeserta.angkatan,
      };
      const queryParams = new URLSearchParams(option).toString();
      try {
        const result = await fetchData(
          event,
          "/file/tjadwal/paging?" + queryParams
        );

        this.years = result.data;
      } catch (error) { }
      this.loading = false;
    },
    Logout() {
      const userStore = useUserStore();
      const delay = 700;
      userStore.$patch({
        snackStatus: "green",
        snackbar: true,
        messageSnack: "Logout Berhasil",
        loggedIn: false,
      });
      setTimeout(() => {
        userStore.$reset();
        navigateTo({ path: "/login" });
      }, delay);
    },
    goBack() {
      this.$router.go(-1);
    },
    CekIcon(jenis) {
      const tanggalSekarang = moment();

      // Ambil tanggal yang ingin Anda periksa (contoh: 15 November 2023)
      const tanggalTarget = moment(jenis);

      // Periksa apakah tanggal sudah kelewat
      if (tanggalSekarang.isAfter(tanggalTarget)) {
        return "mdi-check-all";
      } else {
        return "mdi-close";
      }
    },
    CekColor(jenis) {
      const tanggalSekarang = moment();

      // Ambil tanggal yang ingin Anda periksa (contoh: 15 November 2023)
      const tanggalTarget = moment(jenis);

      // Periksa apakah tanggal sudah kelewat
      if (tanggalSekarang.isAfter(tanggalTarget)) {
        return "primary";
      } else {
        return "red";
      }
    },
  },
};
</script>

<!-- <style>
.bg-primary {
  background: linear-gradient(45deg, #499bea, #449df0);
}
</style> -->
